const key = 'calendar-return-to';
const valid = (href: unknown): href is string =>
  typeof href === 'string' && (href === '/' || href.startsWith('/?'));
export function rememberCalendarReturnTo(href: string): void {
  if (!valid(href)) return;
  try {
    sessionStorage.setItem(key, href);
  } catch {
    /* Storage is optional. */
  }
}
export function calendarReturnTo(): string {
  try {
    const href = sessionStorage.getItem(key);
    return valid(href) ? href : '/';
  } catch {
    return '/';
  }
}
